import {BobTVUser} from '../components/bobtv-neo/BobTVUser/index';
import {LOGIN_SUCCESS} from '../constants/general';
import {ROOM_CLIENT_UPDATE} from '../constants/users';
import {COUNTER_NOTIFICATION} from '../constants/notifications.js';

export default function currentUser(state = new BobTVUser({}), action) {
    if (action.type === LOGIN_SUCCESS) {
        return action.user;
    }

    if (action.type === ROOM_CLIENT_UPDATE) {
        if (state.uid === action.user.uid && state.ufrag === action.user.ufrag) {
            return action.user;
        }
    }

    if (action.type === COUNTER_NOTIFICATION) {
    	if (action.data.name == 'amount_wallet') {
    		let new_user = {
    			...state,
    			wallet_amount: action.data.value
    		}
    		return new BobTVUser(new_user);
    	}
    }


    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/currentUser.js